const BADGE_VARIANT = {
  label: 'label',
  counter: 'counter',
  pip: 'pip'
};

export { BADGE_VARIANT };
